// // Fix change
// if (BSS_B2B) {
//     window.addEventListener("cart_changed", () => {
//         setTimeout(() => {
//             let storeData = JSON.parse($("#bss-b2b-store-data").html());
//             BSS_B2B.makeChangesAfterClickAjaxCart(500)
//             BSS_B2B.cart.fixer(storeData, null, false);
//             BSS_B2B.handleCartCheckoutBtn(storeData);
//             BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false, false)
//         }, 500);
//     });

//     // fix spam checkout
//     setTimeout(() => {
//         function handleButtonClick(e) {
//             e.preventDefault();
//             const $button = $(this);
//             let oldText = $(this).text();
//             $button.css({'pointer-events': 'none', 'opacity': '0.6'});
//             $button.text("Loading ...");
//             setTimeout(() => {
//                 $button.css({'pointer-events': 'unset', 'opacity': '1'})
//                 $button.text(oldText);
//             }, 2000);
//         }
//         $(document).on('click dblclick', 'button[name="checkout"]', handleButtonClick);
//     }, 500)
//     BSS_B2B.customTriggerCheckoutBtn = function (checkoutBtn) {
//         window.location.href = "/checkout";
//     }
// }




const waitDrawer = setInterval(() => {
  const drawer = document.querySelector("cart-drawer");
  if (!drawer) return;

  function fixBssCheckoutButton() {
    const buttons = drawer.querySelectorAll(".bss-checkout");

    buttons.forEach((btn, index) => {
      const isLast = index === buttons.length - 1;

      if (drawer.hasAttribute("open") && isLast) {
        btn.style.setProperty("display", "block", "important");
        btn.style.setProperty("visibility", "visible", "important");
        btn.style.setProperty("opacity", "1", "important");
        btn.style.setProperty("position", "static", "important");
        btn.style.setProperty("transform", "none", "important");
        btn.style.setProperty("left", "auto", "important");
      } else {
        btn.style.setProperty("display", "none", "important");
      }
    });
  }

  const observer = new MutationObserver(() => {
    fixBssCheckoutButton();
  });

  observer.observe(drawer, {
    attributes: true,
    childList: true,
    subtree: true
  });

  fixBssCheckoutButton();

  clearInterval(waitDrawer);
}, 100);




let counter = 0;
const inputTESelector = ".bss-b2b-vat-input";
const typeSelector = ".bss-b2b-vat-selected";

const interval = setInterval(() => {
    let inputTE = document.querySelector(inputTESelector);
    let type = document.querySelector(typeSelector);

    if (inputTE && type) {
        if (!window.bss_customer) return;

        const euVat = (window.bss_customer.eu_vat || "").trim();
        const isGB = euVat.startsWith("GB") || /^[0-9]+$/.test(euVat);

        const vatMap = {
            '0': !isGB ? euVat : null,                 
            '1': isGB ? euVat : window.bss_customer.uk_vat, 
            '2': window.bss_customer.abn,
            '3': window.bss_customer.gst,
            '4': window.bss_customer.us_ein
        };

        const firstValidEntry = Object.entries(vatMap).find(([k, v]) => v);

        if (firstValidEntry) {
            const [key, value] = firstValidEntry;
            type.value = key;
            inputTE.value = value;

            inputTE.style.pointerEvents = "none";
            type.style.pointerEvents = "none";
        } else {
            inputTE.style.pointerEvents = "auto";
            type.style.pointerEvents = "auto";
        }

        type.dispatchEvent(new Event("change"));


        clearInterval(interval);
    } else {
        counter += 100;
        if (counter >= 10000) clearInterval(interval);
    }
}, 100);





const bssTotalFix = setInterval(() => {
  const drawer = document.querySelector("cart-drawer");
  if (!drawer) return;

  function getNumericValue(text) {
    const cleaned = text
      .replace(/[^\d.,-]/g, "")
      .replace(/\s/g, "");

    if (!cleaned) return null;

    const normalized = cleaned
      .replace(/\.(?=\d{3})/g, "")
      .replace(",", ".");

    const value = parseFloat(normalized);

    return Number.isNaN(value) ? null : value;
  }

  function fixTotalPriceLoading() {
    const totals = drawer.querySelectorAll("[bss-b2b-cart-total-price]");

    totals.forEach((total) => {
      const text = total.textContent.trim();
      const value = getNumericValue(text);

      if (value === 0) {
        total.style.setProperty("visibility", "hidden", "important");
      } else {
        total.style.setProperty("visibility", "visible", "important");
      }
    });
  }

  const observer = new MutationObserver(() => {
    fixTotalPriceLoading();
  });

  observer.observe(drawer, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true
  });

  fixTotalPriceLoading();

  clearInterval(bssTotalFix);
}, 100);